export const FROM_LOCATION = {
  ASSIGNMENT: "ASSIGNMENT",
  BUDDY_LIST: "BUDDY_LIST",
};

export const NAMESPACE = {
  AUTH: "auth",
};

export const STUDY_BUDDY_EVENT = {
  ON_SYNC_REQUEST_AND_BUDDY_LIST: "ON_SYNC_REQUEST_AND_BUDDY_LIST",
};

export const BUDDY_REQUEST_ACTION_TYPE = {
  ACCEPT: "ACCEPT",
  REJECT: "REJECT",
};

export const REQUEST_STATUS = {
  REQUEST_SENT: "REQUEST_SENT",
  PENDING_ACCEPTANCE: "PENDING_ACCEPTANCE",
  NOT_SENT: "NOT_SENT",
};

export const BuddyNotificationActionType = {
  PENDING_ACCEPTANCE: "PENDING_ACCEPTANCE",
  BUDDY_ACCEPTED: "BUDDY_ACCEPTED",
};

export const STUDY_BUDDY_ERROR_CODES = {
  MAXIMUM_BUDDY_REQUEST: "maximum-buddy-request",
};
